import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";
import { FeatureFlags } from "@busy-human/vue-component-library";
import { appClasses, updateWindowWidth } from "./app-styling";
import { AppliedLayout } from "./layout";


export default /*@__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props, { expose: __expose }) {
  __expose();

if(process.env.NODE_ENV !== "production") {
	// Maintenance shaft should not be used in production
	// eslint-disable-next-line @typescript-eslint/no-var-requires
	const {useMaintenance} = require("@/util/maintenance");
	useMaintenance();
}

FeatureFlags.registerCondition({ name: "betaTester", context: "beta" }, () => true);

onMounted(() => {
	(window as any).APPLICATION_LOADER.done();
	window.addEventListener("resize", updateWindowWidth);
});

const __returned__ = { onMounted, get FeatureFlags() { return FeatureFlags }, get appClasses() { return appClasses }, get updateWindowWidth() { return updateWindowWidth }, get AppliedLayout() { return AppliedLayout } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})